import { render } from "./DeleteDeviceDialog.vue?vue&type=template&id=62612447"
import script from "./DeleteDeviceDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDeviceDialog.vue?vue&type=script&lang=js"

import "./DeleteDeviceDialog.vue?vue&type=style&index=0&id=62612447&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__